import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, map } from 'rxjs';
import { FileSelectEvent, FileUpload, FileUploadModule } from 'primeng/fileupload';
import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { validate } from 'graphql';
import {
  TextEditorComponent,
  Article,
  ArticleType,
  Destination,
  Tag,
  ArticleCategory,
  DestinationService,
  Picture,
} from '../../../../shared/public-api';

@Component({
  selector: 'admin-article-info',
  templateUrl: './article-info.component.html',
  styleUrls: ['./article-info.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    FileUploadModule,
    SelectModule,
    ToggleSwitchModule,
    InputTextModule,
    DatePickerModule,
    TextEditorComponent,
  ],
})
export class ArticleInfoComponent implements OnInit {
  @Input() articleModel: Article;
  @Output() articleModelChange = new EventEmitter<Article>();
  ArticleType = ArticleType;

  destinations$: Observable<Destination[]>;
  tags$: Observable<Tag[]>;
  articleCategories = [
    {
      label: 'Road trip',
      value: ArticleCategory.RoadTrip,
    },
    {
      label: 'City trip',
      value: ArticleCategory.CityTrip,
    },
    {
      label: 'Randonnée',
      value: ArticleCategory.Hiking,
    },
  ];

  constructor(private destinationService: DestinationService) {}

  ngOnInit(): void {
    // this.tags$ = this.tagService.getTags();
    const defaultDestination = new Destination();
    defaultDestination.id = null;
    defaultDestination.country = 'No destination';
    this.destinations$ = this.destinationService
      .getDestinations()
      .pipe(map((d) => [defaultDestination, ...d]));
  }

  onFileChanged(event: FileSelectEvent): void {
    const files = event.files;

    if (!files || files?.length === 0) {
      return;
    }
    const file = files[0];
    const reader = new FileReader();
    this.articleModel.coverPicture = new Picture(0);
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (this.articleModel.coverPicture) {
        this.articleModel.coverPicture.uploadSrc = reader.result as string;
      }
    };
    this.articleModel.coverPicture.name = file.name;
  }
}
